import React, { useCallback, useEffect, useRef, useState } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { ISlideProps } from "../slide";
import { theme } from "../../../theme";
import { SlideContentSelector } from "../SlideContentSelector";
import { TextContent } from "../slideTextContent";
import {
  backgroundImageStyle,
  mobileWidth,
  titleHeight,
} from "../../../styleUtils";

export const OneElementWithTitleSlide = (props: ISlideProps) => {
  const { setReady } = props;
  const narrowScreen = useMediaQuery(mobileWidth);

  const [contentsReady, setContentsReady] = useState([true, false]);

  const titleHeightValue = titleHeight(!!props.edit, theme);

  const setReadyCallback = useCallback((index: number) => {
    setContentsReady((current) => {
      const newContentsReady = [...current];
      newContentsReady[index] = true;
      return newContentsReady;
    });
  }, []);

  useEffect(() => {
    let result = true;
    for (let i = 0; i < contentsReady.length; i++) {
      if (!contentsReady[i]) result = false;
    }
    if (result) setReady();
  }, [setReady, contentsReady]);

  const withBorder = {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.divider,
    borderRadius: 1,
    marginRight: 1,
  };

  const withoutBorder = {
    borderWidth: 0,
    alignContent: "center",
  };

  const backgroundImage = backgroundImageStyle(props.content[2]?.data);

  return (
    <Grid
      container
      flex={1}
      overflow={props.thumbnailSlide ? undefined : "auto"}
      flexGrow={1}
      padding={theme.spacing(2)}
      sx={backgroundImage}
    >
      <Grid
        item
        xs={12}
        display={"flex"}
        style={{
          // height: narrowScreen ? undefined : titleHeightValue,
          //height: titleHeightValue,
          alignItems: "center",
          justifyContent: "center",
          justifyItems: "center",
          zIndex: 102,
        }}
      >
        <TextContent
          content={(props.content && props.content[0]).data}
          onValueChanged={(val) => props.setContent(0, val)}
          edit={props.edit}
          minimalEditor
          multiline={false}
          title
          height={props.edit ? titleHeightValue : undefined}
          thumbnailSlide={props.thumbnailSlide}
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          ...(props.content && props.content[1].contentType !== "unknown"
            ? withoutBorder
            : withBorder),
          height: `calc(100% - ${titleHeightValue})`,
        }}
      >
        <SlideContentSelector
          content={props.content && props.content[1]}
          setContent={props.setContent}
          edit={props.edit}
          index={1}
          thumbnail={props.thumbnailSlide}
          onSetReady={setReadyCallback}
          organisationId={props.organisationId}
          password={props.password}
        />
      </Grid>
    </Grid>
  );
};
